import { useResponsive } from '@sweetgreen/garnish';

export const useLargeDesktopBreakpoint = () => {
  const { windowWidth, minWidth } = useResponsive();

  return windowWidth >= 1200 && !minWidth.largeDisplay;
};
